module.exports = {
      id: "xau-usage",
      viewBox: "0 0 8 8",
      url: __webpack_public_path__ + "sprite-dd90e0.smartcharts.svg#xau-usage",
      toString: function () {
        return this.url;
      }
    }